import { useEffect, useState } from 'react'
import Script from 'next/script'
import { useRouter } from 'next/router'

import { allowLiveStreamAd } from 'environment'

import { useAppSelector } from 'redux/hooks'

import { ClientFlags } from 'redux/active/actions/types'

import Icon from 'components/elements/Icon'

import styles from './streamAd.module.scss'

type Props = {}

const AUTO_PLAY_CHANNELS: Record<string, boolean> = {
  'asteri': true,
  'edhrecast': false,
}

export const getActiveStream = (clientFlags: ClientFlags): string | null => {
  let activeStream = null

  const twitchStreamMap = clientFlags.twitch
  const twitchActive = twitchStreamMap
    ? Object.keys(twitchStreamMap).find(key => twitchStreamMap[key as keyof typeof twitchStreamMap])
    : null
  if (twitchActive) activeStream = twitchActive

  const asteriIsLive = allowLiveStreamAd(clientFlags.rules.asteriStartTime, clientFlags.rules.asteriStopTime)

  if (asteriIsLive) activeStream = 'asteri'

  return activeStream
}

const StreamAd: React.FC<Props> = () => {
  const [isClient, setIsClient] = useState(false)
  const [isOpen, setIsOpen] = useState(true)
  const [closeVisible, setCloseVisible] = useState(false)

  const clientFlags = useAppSelector(state => state.active.clientFlags)

  const activeStream = getActiveStream(clientFlags)
  const isAsteri = activeStream === 'asteri'
  const router = useRouter()

  const unique_id = new Date().getTime()

  useEffect(() => {
    setIsClient(true)
    setTimeout(() => setCloseVisible(true), 3000)
  }, [])

  if (!isAsteri && !activeStream) return null
  if (!isClient || !isOpen) return null
  if (window.innerWidth <= 600) return null

  // Explictly disable autoplay for edhrecast
  // Will need to update this at a later point if we add more channels
  const autoPlay = AUTO_PLAY_CHANNELS[activeStream] || false

  return (
    <div key={router.asPath} className={styles.container}>
      <div className={styles.innerContainer}>
        {isAsteri && (
          <>
            <div
              // @ts-ignore
              asterilivestream_profile="116_96"
              asterilivestream_width={window.innerWidth <= 600 ? 160 : 300}
              asterilivestream_height={window.innerWidth <= 600 ? 90 : 250}
            />
            <Script
              id={`${unique_id}`}
              type="text/javascript"
              src="https://asteriresearch.com/livestream-latest.min.js"
              async
            />
          </>
        )}

        {!isAsteri && activeStream && (
          <iframe
            src={`https://player.twitch.tv/?channel=${activeStream}&parent=topdekt.com&parent=archidekt.com&muted=true&autoplay=${autoPlay}`}
            height={window.innerWidth <= 600 ? 90 : 300}
            width={window.innerWidth <= 600 ? 160 : 400}
            allowFullScreen></iframe>
        )}

        {closeVisible && (
          <button className={styles.closeButton} onClick={() => setIsOpen(false)}>
            <Icon name="close" />
          </button>
        )}
      </div>
    </div>
  )
}

export default StreamAd
